import React from 'react'

import PrevIcon from '../icons/prev.svg'
import NextIcon from '../icons/next.svg'
import ListIcon from '../icons/lists.svg'

import Link from '../components/Link'

import {
  PREVIEW_STAGE,
  NEXT_STAGE,
  STAGE_LIST
} from '../trans'

const TrailNavigation = (props) => {
  const { prevTrail, backLink, nextTrail } = props

  return (
    <nav className="pwa__paginator">
      { prevTrail && (
        <Link to={ prevTrail }
              title={window.gettext('go to preview stage')}
          className="pwa__paginator__item button basic">
          <PrevIcon aria-hidden={true}/>
          <span>{ PREVIEW_STAGE }</span>
        </Link>
      )}
      { !prevTrail && (
        <div className="pwa__paginator__item button basic disabled" aria-hidden={true}>
          <PrevIcon/>
          <span>{ PREVIEW_STAGE}</span>
        </div>
      )}
      <Link to={ backLink }
        title={window.gettext('go to stage list')}
        className="pwa__paginator__item button basic">
        <ListIcon aria-hidden={true}/>
        <span>{ STAGE_LIST }</span>
      </Link>
      { nextTrail && (
        <Link to={ nextTrail }
          title={window.gettext('go to next stage')}
          className="pwa__paginator__item button basic">
          <span>{ NEXT_STAGE }</span>
          <NextIcon aria-hidden={true}/>
        </Link>
      )}
      { !nextTrail && (
        <div className="pwa__paginator__item button basic disabled" aria-hidden={true}>
          <span>{ NEXT_STAGE  }</span>
          <NextIcon/>
        </div>
      )}
    </nav>
  )
}

export default TrailNavigation
